import { render } from "./BasePopUp.vue?vue&type=template&id=f5c98578&scoped=true"
import script from "./BasePopUp.vue?vue&type=script&lang=js"
export * from "./BasePopUp.vue?vue&type=script&lang=js"

import "./BasePopUp.vue?vue&type=style&index=0&id=f5c98578&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\git\\CatalogOnVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5c98578"]])

export default __exports__